export default __webpack_public_path__ + "static/5-e011960a5db0bb85cdcd56bfca379143.jpg";